<template>
  <v-dialog v-model="dialog" max-width="900" :persistent="true">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ 'app.prescriptions.select_prescription' | trans}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <prescriptions-table @prescription-selected="prescriptionSelectedListener" :mode="'select'" ref="prescriptionsTable"></prescriptions-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  data: () => ({
    dialog: false,
    prescriptionSelected: false,
  }),
  methods: {
    close() {
      if (!this.prescriptionSelected) {
        this.$emit('closed-without-selecting')
      }
      this.dialog = false;
    },
    show() {
      this.prescriptionSelected = false;
      this.$refs.prescriptionsTable.fetchData();
      this.dialog = true;
    },
    prescriptionSelectedListener(prescription) {
      this.prescriptionSelected = true;
      this.$emit('prescription-selected', prescription);
      this.close();
    }
  },
};
</script>
